import {
	CREATE_CART_BEGIN,
	CREATE_CART_SUCCESS,
	CREATE_CART_ERROR,
} from '../actions/createCart'

import merge from 'lodash/merge'

const initialState = {
	cart: [],
	loading: false,
	error: null,
}

export default function createCartReducer(state = initialState, action) {
	switch(action.type) {
		case CREATE_CART_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case CREATE_CART_SUCCESS:
			return {
				...state,
				loading: false,
				cart: merge({}, state.confirmation, action.payload)
			}

		case CREATE_CART_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				cart: [],
			}

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/createCartReducers.js